<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <v-btn
        small
        text
        rounded
        fab
        color="success"
        :to="{ name: 'Recipes'}">
        <v-icon>
          mdi-arrow-left
        </v-icon>
      </v-btn>
      <div class="title primary--text">{{ section }}</div>
      <v-spacer />
    </div>
    <div class="noto bold pa-3 d-md-flex align-center" style="width: 350px;">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Buscar recetas por nombre"
        solo
        hide-details
        rounded
        flat
        dense />
    </div>

    <v-flex xs12>
      <v-data-table
        :loading-text="table.title"
        :server-items-length="table.total"
        :loading="table.loading"
        :headers="table.headers"
        :items="table.data"
        :options="table.options"
        no-data-text="No hay recetas archivadas aún"
        :footer-props="{'items-per-page-options': [50, 100]}"
        @update:options="updateTable"
        class="elevation-1">
         <template v-slot:item.name="{ item }">
          <div>
            <span>
              {{ item.name }}
            </span>
          </div>
          <div class="caption grey--text">
            <span v-if="item.internalId">
              {{ item.internalId }}
            </span>
            <span v-else>
              -
            </span>
          </div>
        </template>
        <template v-slot:item.section="{ item }">
          <span v-if="item.section">
            {{ item.section.name }}
          </span>
          <span v-else>
            -
          </span>
        </template>
        <template v-slot:item.cost="{ item }">
          <div class="text-right">
            <div v-if="item.price">
              {{ item.cost | percentOf(item.price) | toFixNumber }}%
            </div>
            <div v-else>
              -
            </div>
            <div class="caption grey--text">
              ${{ item.cost | toFix2 | numberWithComma }}
            </div>
          </div>
        </template>
         <template v-slot:item.previousPrice="{ item }">
          <div class="text-right">
            <span v-if="item.previousPrice > 0">
              ${{ item.previousPrice | toFix2 | numberWithComma }}
            </span>
            <span v-else>
              -
            </span>
          </div>
        </template>
        <template v-slot:item.price="{ item }">
          <div class="text-right">
            <span v-if="item.price >= 0">
              ${{ item.price | toFix2 | numberWithComma }}
            </span>
            <span v-else>
              -
            </span>
          </div>
        </template>
        <template v-slot:item.status="{ item }">
         {{item.status === 'archived' ? 'Archivada' : item.status}}
        </template>
        <template v-slot:item.area="{ item }">
         {{item.area.name}}
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex justify-end align-center">
            <div class="mx-1">
                <v-tooltip left>
                  <template
                    v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      fab
                      x-small
                      depressed
                      color="primary"
                      @click="openArchiveRecipeDialog(item)"
                    >
                      <v-icon
                        icon
                        small
                      >mdi-archive</v-icon>
                    </v-btn>
                  </template>
                <span>Desarchivar receta</span>
                </v-tooltip>
            </div>
            <div class="mx-1">
              <v-tooltip left>
                <template
                  v-slot:activator="{ on }">
                  <v-btn
                    fab
                    x-small
                    depressed
                    color="error"
                    v-on="on"
                    @click="openRemoveRecipeDialog(item)">
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar receta</span>
              </v-tooltip>
            </div>
          </div>
        </template>
      </v-data-table>
    </v-flex>

    <v-dialog @keydown.esc="archiveRecipeDialog=false" v-model="archiveRecipeDialog" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">¿Desarchivar la receta {{ form.data.name }}?</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black darken-1" text @click="onCloseArchiveDialog">{{ $t('messages.no') }}</v-btn>
          <v-btn color="black darken-1" text @click="unArchiveRecipes">{{ $t('messages.yes') }}</v-btn>
        </v-card-actions>
      </v-card>
      <v-overlay :value="overlayDialog" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    </v-dialog>

   <v-dialog @keydown.esc="removeRecipeDialog=false" v-model="removeRecipeDialog" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">¿Eliminar la receta {{ form.data.name }}?</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black darken-1" text @click="onCloseRemoveDialog">{{ $t('messages.no') }}</v-btn>
          <v-btn color="black darken-1" text @click="remove">{{ $t('messages.yes') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-layout>
</template>

<script>
import { debounce } from 'lodash'

export default {
  name: 'ArchivedRecipes',
  data () {
    return {
      overlay: false,
      section: 'Recetas archivadas',
      table: {
        title: 'Recetas archivadas',
        loading: false,
        headers: [
          { text: 'Nombre de receta', value: 'name', sortable: false },
          { text: 'Sección', value: 'section', sortable: false },
          { text: 'Precio anterior', value: 'previousPrice', sortable: false },
          { text: 'Precio de venta', value: 'price', sortable: false },
          { text: 'Costo', value: 'cost', sortable: false },
          { text: 'Promedio de venta semanal', value: 'avgWeeklySale', sortable: false, alight: 'right' },
          { text: 'Área', value: 'area', sortable: false },
          { text: 'Estatus', value: 'status', sortable: false },
          { text: 'Actiones', value: 'actions', sortable: false }
        ],
        data: [],
        options: {
          itemsPerPage: 50,
          page: 1
        }
      },
      archiveRecipeDialog: false,
      form: {
        data: {
          internalId: null,
          name: null,
          status: null,
          subrecipe: false,
          restaurant: null,
          area: null,
          section: null
        }
      },
      overlayDialog: false,
      removeRecipeDialog: false,
      search: ''
    }
  },
  computed: {
    restaurant () {
      return this.$store.state.currentRestaurant.data
    }
  },
  watch: {
    'search': debounce(async function (val) {
      if (val.length >= 2) {
        try {
          const response = await this.$api.get('/v1/recipes/archived', { skip: 0, name: `/${val}/i` })
          this.table.data = response.data.sort((a, b) => {
            if (a.name > b.name) return 1
            if (a.name < b.name) return -1
            return 0
          })
          this.table.total = response.total
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
      } else {
        this.load()
      }
    }, 300),
    restaurant: {
      handler: async function (val) {
        await this.load()
      },
      deep: true
    }
  },
  async mounted () {
    await this.load()
  },
  methods: {
    updateTable: async function (data) {
      this.table.options = data
      const params = {
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1))
      }
      try {
        await this.load(params)
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
    },
    async load (params = null) {
      params = params || {
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1))
      }

      params.restaurant = this.restaurant._id

      this.table.loading = true
      try {
        const response = await this.$api.get('/v1/recipes/archived', params)
        this.table.data = response.data
        this.table.total = response.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.loading = false
    },
    openArchiveRecipeDialog: async function (recipe) {
      this.form.data = recipe
      this.archiveRecipeDialog = true
    },
    onCloseArchiveDialog: function () {
      this.archiveRecipeDialog = false
    },
    unArchiveRecipes: async function () {
      this.overlayDialog = true
      try {
        await this.$api.post(`/v1/recipes/${this.form.data.uuid}/archived`, { unArchive: true })
        this.onCloseArchiveDialog()
        await this.load()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlayDialog = false
    },
    openRemoveRecipeDialog: async function (recipe) {
      this.form.data = recipe
      this.removeRecipeDialog = true
    },
    onCloseRemoveDialog: function () {
      this.removeRecipeDialog = false
    },
    remove: async function () {
      this.table.loading = true
      try {
        await this.$api.post(`/v1/recipes/${this.form.data.uuid}/delete`)
        await this.load()
        this.onCloseRemoveDialog()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.loading = false
    }
  }
}
</script>

<style lang="scss">
.action-black {
  color: black !important;
}
.z-index--100 {
  z-index: 100 !important;
}
</style>
